module.exports = __webpack_public_path__ + "static/media/gallery28.36af8472.png";